/**
* Asserts condition, throws an error if not.
* @param condition The condition to assert.
* @param message The message to throw.
*/
export function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
//# sourceMappingURL=Assert.js.map